var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_vm._v("OX25")]),_c('Game'),_c('footer',[_vm._v("Copyright (c) 2020 yamunaku")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }